import WidgetOptions from "../WidgetOptions";
import React from "react";
import PropTypes from "prop-types";

const TitleWidget = ({
     widgetDisplayName = "",
     titlePosition = "center",
     hasSeparator = false,
     isEditMode = false,
     isDashboardFullScreen = false,
     onEditClick = () => { },
     onForceUpdateClick = () => { },
     onDuplicateClicked = () => { },
     onDeleteClicked = () => { },
 }) => {
    return (
        <div className={isEditMode && "widget p-total-0"} style={{overflowY: "overlay", overflow: isEditMode && "hidden"}}>
            <div className="row">
                <div className="col-lg-12 wordBreak">
                    <div className="titleWidget-container">
                        <WidgetOptions
                            isEditMode={isEditMode}
                            className="widget-options-contained widget-options-effect pd-r-15"
                            onEditClicked={onEditClick}
                            isDashboardFullScreen={isDashboardFullScreen}
                            onRefreshClicked={onForceUpdateClick}
                            onDuplicateClicked={onDuplicateClicked}
                            onDeleteClicked={onDeleteClicked}
                        />
                        <span className={"titleWidget-text mt-3 " + titlePosition} >
                            <b>{widgetDisplayName}</b></span>
                        <div className={hasSeparator && "titleWidget-border"}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

TitleWidget.propTypes = {
    hasSeparator: PropTypes.bool,
    titlePosition: PropTypes.string,
    widgetDisplayName:  PropTypes.string,
    isEditMode: PropTypes.bool,
    isDashboardFullScreen: PropTypes.bool,
    onEditClick: PropTypes.func,
    onDuplicateClicked: PropTypes.func,
    onDeleteClicked: PropTypes.func
};

export default TitleWidget;